import { ChatService } from "@/services";
import { CHAT_QUERY_KEYS, NewChatParams } from "@/types";
import { toastApiError, toastSuccess } from "@/utils";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export const useCreateChat = () => {
  const queryClient = useQueryClient();

  const { mutateAsync, isPending } = useMutation({
    mutationKey: [CHAT_QUERY_KEYS.CREATE_CHAT],
    mutationFn: async (data: NewChatParams) => ChatService.createChat(data),
    retry: 1,
    onSuccess: (data) => {
      toastSuccess(data.message || "チャットが作成されました");

      // reset list chat rooms
      queryClient.invalidateQueries({ queryKey: [CHAT_QUERY_KEYS.ALL_CHATS] });
    },
    onError: toastApiError,
  });

  return {
    createChat: mutateAsync,
    isCreating: isPending,
  };
};
